import {useMutation} from '@tanstack/react-query';
import {fetchRest} from '../helpers/fetchRest';
import utils from '../helpers/utils';

/**
 * Triggers member-api cleanup when NGP logout occurs.
 */
export const useLogout = () => {
  const mutation = useMutation({
    mutationKey: ['logout'],
    mutationFn: () => {
      const config: FetchConfig = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      };
      return fetchRest(utils.getLogoutPath(), config);
    },
    onSettled: () => {
      utils.clearSessionAndCookies();
    },
  });
  return mutation;
};
